<template>
  <div :id="screenName" v-if="contentNotFound" class="recommendation">
    <categoriesPlaceholder :screen="screen" :id="id" v-if="interSected && !sliderContents" />
    <Slider v-else-if="!interSected && sliderContents && sliderContents.length > 0" :screen="screen"
      :contentList="sliderContents" :screenName="screenName" :id="id" :title="'top'" :playerInstance="playerInstance"
      @reachEnd="reachEnd" :screenId="screenId">
    </Slider>
  </div>
</template>

<script>
import categoriesPlaceholder from "@/components/placeholders/categoriesPlaceholder.vue";
import { eventBus } from "@/eventBus";
import { mapGetters, mapActions } from "vuex";
import Intersect from 'vue-intersect'
import { store } from "@/store/store";
import Utility from "@/mixins/Utility.js";

export default {
  props: {
    screen: {
      type: Object,
    },
    id: {
      type: String,
    },
    screenName: {
      type: String,
    },
    localLang: {
      type: String,
    },
    playerInstance: {
      type: Object,
    },
    screenId: {
      type: String,
    },
  },
  data() {
    return {
      contentList: false,
      showSlider: true,
      sliderContents: null,
      localDisplayLang: null,
      isMpegRequired: false,
      loading: true,
      contentNotFound: true,
      currentPage: 1,
      totalCountValue: 0,
      checkIsok: null,
      interSected: false,
    };
  },
  computed: {
    ...mapGetters(["getToken", "currentBrowser", "subscriberid", "appConfig"]),
  },
  watch: {
    screenName() {
      this.sliderContents = null;
      this.loadCategory();
    }
  },
  created() {
    // this.isMpegRequired = this.checkMpegRequired();
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;

    eventBus.$on("check-local-storage", (data) => {
      this.localDisplayLang = data;
      // this.loading = true;
      this.loadCategory();
    });
  },
  mounted() {
    // console.log('screenName', this.screenName)
    this.createObserver();
    // this.loadCategory();
  },
  methods: {
    ...mapActions(["listContent"]),
    reachEnd() {
      if (this.totalCountValue == this.sliderContents.length) return;
      this.currentPage = this.currentPage + 1;
      this.loadCategory();
    },
    filterContentList(response) {
      this.sliderContents = [];
      if (!response.reason) {
        this.interSected = false;
        this.checkIsok = false;

        this.loading = false;
        this.contentList = true;
        let itemCase = JSON.parse(JSON.stringify([...this.sliderContents, ...response.data]))
        this.sliderContents = itemCase;
        this.totalCountValue = response.totalcount
        let dataLength = this.sliderContents.length;
        eventBus.$emit("on-data-callback", { "index": this.id, "is_data_available": dataLength > 0 });
      } else {
        // this.contentList = true;
        // this.showSlider = false;
        this.loading = false;
        this.checkIsok = false;
        this.contentNotFound = false;
        // eventBus.$emit("on-data-callback", {"index": this.id, "is_data_available": false});

      }
    },
    checkMpegRequired() {
      let isMpegRequired = false;
      let videoTag = document.createElement("video");
      let platformOs = navigator.platform;

      if (videoTag.canPlayType("application/vnd.apple.mpegurl")) {
        if (platformOs.startsWith("Mac")) {
          isMpegRequired = true;
        }
      }

      return isMpegRequired;
    },
    getEndPoint() {
      const sectionType = this.screen.sectionType;
      const itemType = this.screen.itemType;

      if (sectionType == "ITEMLIST" && itemType == "CONTENT") {
        return "subscriber/v1/content"
      } else if (sectionType == "ITEMLIST" && itemType == "TRAILERS") {
        return "subscriber/v1/metadata/trailer"
      } else if (sectionType == "ITEMLIST" && itemType == "CASTNCREW") {
        return "subscriber/v1/metadata/castncrew"
      } else {
        return "subscriber/v1/content"
      }
    },
    categoryList(data) {
      store
        .dispatch("contentList", data)
        .then((response) => {
          if (response.data) {
            if (data.type && data.type === "bold") {
              eventBus.$emit("bold-contents", response.data);
            } else {
              this.filterContentList(response.data);
            }
          }
        })
        .catch((error) => { console.log(error, 'error') });
    },
    loadCategory() {
      // console.log("sectionType", this.screen.sectionType, ",,", this.appConfig.apiUtilities.vRecommendations, "--", this.appConfig.apiUtilities.topRecommendations)
      let payload = {};
      if (this.screen.sectionType === "USERRECOMMENDED") {
        if (this.screen.ruleid) {
          payload.params = {
            ruleid: this.screen.ruleid
          }
        }
        payload.endpoint = this.appConfig.apiUtilities.vRecommendations;

      } else if (this.screen.sectionType === "TOPRECOMMENDED") {
        if (this.screen.ruleid) {
          payload.params = {
            ruleid: this.screen.ruleid
          }
        }
        payload.endpoint = this.appConfig.apiUtilities.topRecommendations;
      }
      store
        .dispatch("userRecommendations", payload)
        .then((response) => {
          if (response.data) {
            if (response.data.type && response.data.type === "bold") {
              eventBus.$emit("bold-contents", response.data);
            } else {
              this.filterRecommendedList(response.data?.data);
            }
          }
        })
        .catch((error) => { console.log(error, 'error') });
    },
    createObserver() {
      let observer;
      let boxElement = document.getElementById(`${this.screenName}`);
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      };

      observer = new IntersectionObserver(this.handleIntersect, options);
      observer?.observe(boxElement);
    },
    handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.sliderContents) {
          this.interSected = true;
          this.loadCategory();
        }
      })
    },
    filterRecommendedList(list) {
      if (this.isEmpty(list)) {
        this.contentNotFound = false;
        return;
      }
      const seriesObjIds = [];
      list.map((element) => {
        seriesObjIds.push(`"${element}"`);
      })
      const payload = {
        contentlist: "[" + seriesObjIds + "]",
        // contentlist: list,
        displaylanguage: this.localDisplayLang,
        notincontentprovider: ["hotgo"],
        // pagesize: list.length
        // page: this.pageNum
      };
      // console.log('payload_filterRecommendedList', payload)
      this.listContent(payload).then((data) => {
        // console.log('sliceList', data)
        let sliceList = data.data.data;
        // console.log('sliceList', sliceList)
        let contentListArray = Array.isArray(payload.contentlist) ? payload.contentlist : JSON.parse(payload.contentlist);
        let orderedSliderContents = [];
        contentListArray.forEach((contentId) => {
          // Find the matching item in sliceList
          let matchedItem = sliceList.find(item => item.objectid === contentId);
          if (matchedItem) {
            orderedSliderContents.push(matchedItem);
          }
        });
        this.sliderContents = [...orderedSliderContents];
        this.interSected = false;
        // console.log('sliderContents', this.sliderContents)
        this.loading = false;
        this.totalCountValue = data.data.totalcount;
        let dataLength = this.sliderContents.length;
        eventBus.$emit("on-data-callback", { "index": this.id, "is_data_available": dataLength > 0 });
        // this.paginationForRecommendation(data.data.totalcount, data.data.data);
      }).catch((err) => {
        this.contentNotFound = false;
        // console.log('top10Error', err);
      });
    },
    isEmpty(value) {
      return (
        value != null &&
        typeof value === 'object' &&
        Object.keys(value).length === 0
      );
    }
  },
  components: {
    Intersect,
    categoriesPlaceholder,
    // categorySlider,
    Slider: () => import('@/themeearth/components/dashboard/sliderCarousel/Slider.vue'),
    continueWatchingPlaceholder: () => import(/* webpackchunkname: continueWatchingPlaceholder */ "@/components/placeholders/continueWatchingPlaceholder.vue"),
  },
};
</script>

<style></style>
